export class Entity {
    id: string;

    constructor(obj?: any) {
        this.id = obj && obj.id || "";
    }

    toJSON(): any {
        return this;
    }
}

export function getEntityId (entity: IEntity) {
    return typeof entity === "string" ? entity : entity.id;
}

export type IEntity = Entity | string;